import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, ViewChild } from '@angular/core';
import { MatTabChangeEvent, MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { MatCardModule } from '@angular/material/card';
import { NewRepApplicationPage } from '../new-rep-application/new-rep-application/new-rep-application.page';
import { OnboardingComments } from '../onboarding-comments/onboarding-comments';
import { SnackbarService } from '../../../shared/services/snackbar/snackbar.service';
import { OnboardingCommentsService } from '../onboarding-comments/onboarding-comments-service/onboarding-comments.service';
import { Router } from '@angular/router';
import { SessionStorageService } from '../../../core/services/session-storage/session-storage.service';
import { HttpStatusCode } from 'axios';
import { ViewOnboardingcomments } from '../onboarding-comments/onboarding-comments-interface/view-onboardingcomments.interface';
import { IntroducerFormIndividualComponent } from '../new-introducer/introducer-form-individual/introducer-form-individual.component';
import { IntroducerFormCorporateComponent } from '../new-introducer/introducer-form-corporate/introducer-form-corporate.component';

@Component({
  selector: 'app-applicant-navigation',
  imports: [
    CommonModule,
    MatTabsModule,
    MatCardModule,
    MatTabGroup,
    NewRepApplicationPage,
    OnboardingComments,
    IntroducerFormIndividualComponent,
    IntroducerFormCorporateComponent

  ],
  standalone: true,
  templateUrl: './applicant-navigation.page.html',
  styleUrl: './applicant-navigation.page.scss'
})
export class ApplicantNavigationPage implements OnInit {
  @ViewChild('RmTabs') tabGroup!: MatTabGroup;
  protected selectedTabId: string = "";
  selectedIndex: number = 0;
  private snackBarService = inject(SnackbarService);
  private onboardingCommentsService = inject(OnboardingCommentsService);
  private router = inject(Router);
  private sessionStorageService = inject(SessionStorageService);

  viewId!: number;
  protected currentUserRole: string = "";
  viewReturnComments!: ViewOnboardingcomments[];
  onboardingComments!: string;
  status!: string;


  totalTabs: number = 2;
  constructor() { }
  ngOnInit(): void {
    this.selectedTabId = "new-repapplication";
    this.currentUserRole = this.sessionStorageService.getCurrentUserRole();
    this.status = this.sessionStorageService.getCurrentApplicantStatus();
    if (['NEWREP', 'Introducer - Individual', 'Introducer - Corporate'].includes(this.currentUserRole)) {
      this.viewId = Number(this.sessionStorageService.getCurrentUserId());
      this.getreturnComments();
    }
  }

  protected __onAgentOnboardingTabChange(event: MatTabChangeEvent) {
    if (event.tab.id) {
      this.selectedTabId = event.tab.id.toString();
    }
    else {
      console.error(`Invalid tab ID for mat-tab[${event.index}]`);
    }
  }

  async getreturnComments() {
    const responseData = await this.onboardingCommentsService
      .returnComments(this.viewId)
      .then((response) => {
        return JSON.parse(response);
      })
      .catch((error) => {
        // console.error(error);
        return error;
      });


    if (responseData.status === HttpStatusCode.Ok) {
      this.viewReturnComments = responseData.data.responsedata;
      this.viewReturnComments.forEach((item) => {
        if (this.status == 'Candidate Update (Due Diligence)') {
          if (item.status == 'Onboarding Processing') {
            this.onboardingComments = item.remarkContent
          }
        }
        if (this.status == 'Candidate Update (Assessment)') {
          if (['Introducer - Individual', 'Introducer - Corporate'].includes(this.currentUserRole)) {
            if (item.status == 'DSU Final Assessment') {
              this.onboardingComments = item.remarkContent
            }
          }
          else {
            if (item.status == 'DSU Initial Assessment') {
              this.onboardingComments = item.remarkContent
            }
          }
        }
      });

    } else {
      if (responseData.code === HttpStatusCode.BadRequest) {
        // Display notification on API failure.
        this.snackBarService.openFailureSnackBar("We couldn’t process your request. Please try again");
      }
      if (responseData.code === HttpStatusCode.Unauthorized) {
        this.snackBarService.openFailureSnackBar("Session timed out. Try logging in again!");
        this.router.navigate(['/login']);
      }
    }
  }

}
